import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap"; // Using Bootstrap Modal

const SelectionModal = ({ show, handleClose, onSelect }) => {
    const [selectedOption, setSelectedOption] = useState(null);
       // const [selectedOption, setSelectedOption] = useState(null);

    // // Define options with image paths
    // const options = [
    //     { name: "Auto-Spare", image: "/images/Auto-Spare-Parts.jpg" },
    //     { name: "Engineering", image: "/images/engineering.jpeg" },
    //     { name: "Building", image: "/images/building.jpg" },
    // ];

    // const handleSelect = (option) => {
    //     setSelectedOption(option.name);

    //     sessionStorage.setItem("businessType", option.name);
    //     setSelectedOption(option.name);
    // };

    // const handleConfirm = () => {
    //     if (selectedOption) {
    //         handleClose(); // Close the modal if an option is selected
    //     } else {
    //         alert("Please select an option before closing.");
    //     }
    // };


    const options = [
        { name: "Auto-Spare", image: "/images/Auto-Spare-Parts.jpg" },
        { name: "Marine And Engineering", image: "/images/EngNewImg.jpg" },
        { name: "Building", image: "/images/BldNewImg.jpg" },
         { name: "Rental", image: "/images/Rental.jpg" },
    ];

    const handleSelect = (option) => {
        setSelectedOption(option.name);
        sessionStorage.setItem("businessType", option.name);
    };

    const handleConfirm = () => {
        if (selectedOption) {
            onSelect(selectedOption);  // Notify App component of selection
            handleClose(); // Close the modal
        } else {
            alert("Please select an option before closing.");
        }
    };

    return (
      <Modal show={show} size="lg" backdrop="static" keyboard={false} centered>
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold text-black">
            Select a Business Type
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center py-4">
          <div
            className="d-flex flex-wrap justify-content-center gap-3"
            style={{
              padding: '10px',
            }}
          >
           {[0, 2].map((startIndex) => (
  <div
    key={startIndex}
    className="d-flex justify-content-center gap-3 mb-3"
  >
    {options.slice(startIndex, startIndex + 2).map((option) => (
      <div
        key={option.name}
        className={`option-card ${selectedOption === option.name ? "selected" : ""}`}
        onClick={() => handleSelect(option)}
        style={{
          cursor: "pointer",
          textAlign: "center",
          width: "100%",
          maxWidth: "180px",
          padding: "10px",
          borderRadius: "10px",
          boxShadow:
            selectedOption === option.name
              ? "0px 0px 10px rgba(0, 123, 255, 0.5)"
              : "0px 0px 5px rgba(0, 0, 0, 0.1)",
          transition: "transform 0.3s ease, box-shadow 0.3s ease",
        }}
      >
        <img
          src={option.image}
          alt={option.name}
          style={{
            width: "100%",
            height: "120px",
            objectFit: "cover",
            borderRadius: "8px",
          }}
        />
        <p className="fw-semibold mt-2">{option.name}</p>
      </div>
    ))}
  </div>
))}

          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            variant="primary"
            onClick={handleConfirm}
            disabled={!selectedOption}
            style={{
              width: '100%',
              maxWidth: '200px',
              fontWeight: 'bold',
              backgroundColor: '#007bff',
              borderColor: '#007bff',
              boxShadow: '0px 4px 6px rgba(0, 123, 255, 0.3)',
              transition: 'background-color 0.3s, box-shadow 0.3s',
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = '#0056b3')}
            onMouseOut={(e) => (e.target.style.backgroundColor = '#007bff')}
          >
            Confirm Selection
          </Button>
        </Modal.Footer>
      </Modal>
    );
};

export default SelectionModal;
